export default __webpack_public_path__ + "static/bags-shopping-light.png";